export default __webpack_public_path__ + "empty-job-failed-md.b4806d6a.svg";